import { createSelector } from 'reselect'
import { selectBase } from './selectBase'

export const selectIsBillingDataLoaded = createSelector(
  selectBase,
  base => !!base.isLoaded
)
